import { render, staticRenderFns } from "./Mainnavigation.vue?vue&type=template&id=4e6aec38&"
import script from "./Mainnavigation.vue?vue&type=script&lang=js&"
export * from "./Mainnavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports